const IS_ANDROID = /Android/i.test(navigator.userAgent);
const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === `MacIntel` && navigator.maxTouchPoints > 1);

export class Sensor extends EventTarget {
    constructor() {
        super();
        this._listening = false;
        this._data = null;
        this._boundHandler = null;
    }

    // Platform detection
    get isAndroid() {
        return IS_ANDROID;
    }
    get isIOS() {
        return IS_IOS;
    }
    get isListening() {
        return this._listening;
    }
    get data() {
        return this._data;
    }

    // Permission request helper
    async requestPermission(EventClass) {
        if (typeof EventClass?.requestPermission === `function`) {
            const permission = await EventClass.requestPermission();
            return permission === `granted`;
        }
        return true;
    }


    // Angle math utilities
    normalizeAngle(angle) {
        angle = angle % 360;
        return angle < 0 ? angle + 360 : angle;
    }

    shortestAngleDelta(from, to) {
        let delta = this.normalizeAngle(to) - this.normalizeAngle(from);

        if (delta > 180) {
            delta -= 360;
        }

        if (delta < -180) {
            delta += 360;
        }

        return delta;
    }

    lerpAngle(current, target, alpha) {
        const delta = this.shortestAngleDelta(current, target);
        return this.normalizeAngle(current + delta * alpha);
    }

    // Lifecycle methods
    async start() {
        throw new Error(`start() must be implemented`);
    }

    stop() {
        throw new Error(`stop() must be implemented`);
    }

    dispose() {
        this.stop();
        this._data = null;
    }
}

export default Sensor;
